<script lang="ts" setup>
import SvgLoader from '@/utils/SvgLoader.vue';
import { ref, watch } from 'vue';

const props = withDefaults(
  defineProps<{
    text: string;
    icon: string;
    propDisabled?: boolean;
    colorStyle?: 'default' | 'secondary';
    isIconLeftSide?: boolean;
  }>(),
  {
    colorStyle: 'default',
  }
);

const disabled = ref<boolean>(props.propDisabled ?? false);

watch(
  () => props.propDisabled,
  (newVal) => (disabled.value = newVal ?? false)
);

const emit = defineEmits<{ (e: 'click'): void }>();
</script>
<template>
  <button class="text-icon-button" :class="`text-icon-button--${colorStyle}`" :disabled="disabled" @click="emit('click')">
    <SvgLoader v-if="isIconLeftSide" :name="props.icon" />
    {{ text }}
    <SvgLoader v-if="!isIconLeftSide" :name="props.icon" />
  </button>
</template>
<style lang="scss" scoped>
.text-icon-button {
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;

  height: 32px;
  padding: 0 16px;
  border-radius: 4px;
  gap: 2px;

  font-size: 14px;
  font-weight: 700;
  font-family: 'Noto Sans JP';
  &:disabled {
    background-color: $surfaceDisable;
  }
  &--default {
    background-color: $semanticPrimary;
    color: white;
  }
  &--secondary {
    background-color: white;
    color: $semanticPrimary;
    border: solid 1px $semanticPrimary;
  }
}
</style>
